/* Copyright (c) 2024 Xperi. All Rights Reserved. */

export const OVERLAY_DIALOG_SET_IS_CARET_VISIBLE = 'OVERLAY_DIALOG_SET_IS_CARET_VISIBLE';
export const SET_OVERLAY_DIALOG_STATE = 'SET_OVERLAY_DIALOG_STATE';
export const SET_OVERLAY_DIALOG_TIMER_ID = 'SET_OVERLAY_DIALOG_TIMER_ID';
